// Get the current port from the URL or use default
const getCurrentPort = () => {
  if (typeof window !== 'undefined') {
    const port = window.location.port;
    if (port && port !== '80' && port !== '443') {
      return port;
    }
  }
  return '8081'; // Default fallback port
};

const API_BASE_URL = process.env.NODE_ENV === 'production' 
    ? '/submission'  // Use subfolder in production
    : `http://localhost:${getCurrentPort()}/submission`;  // Use dynamic port in development

export const API_ENDPOINTS = {
    LOGIN: `${API_BASE_URL}/api/token`,
    REGISTER: `${API_BASE_URL}/api/register`,
    SUBMISSIONS: `${API_BASE_URL}/api/submissions`,
    SUBMISSIONS_TASK: `${API_BASE_URL}/api/submissions/task`,
    TASKS: `${API_BASE_URL}/api/tasks`,
    CURRENT_YEAR: `${API_BASE_URL}/api/current-year`,
    FILES: `${API_BASE_URL}/api/files`,
    ME: `${API_BASE_URL}/api/me`,
    CHANGE_PASSWORD: `${API_BASE_URL}/api/change-password`,
    // New upload endpoints
    UPLOAD_START: `${API_BASE_URL}/api/upload/start`,
    UPLOAD_CHUNK: `${API_BASE_URL}/api/upload/chunk`,
    UPLOAD_FINALIZE: `${API_BASE_URL}/api/upload/finalize`,
    UPLOAD_STATUS: `${API_BASE_URL}/api/upload/status`,
}; 